export { LanguageProvider } from './LanguageProvider';
import { LanguageProvider } from './LanguageProvider';
export var __ = function (msg) {
    var langJson = LanguageProvider.translations || {};
    return langJson[msg] || msg;
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-i18n/lib/index.js
// module id = 313
// module chunks = 1